import React, { useMemo } from 'react';

const getSourceBadge = (sourceType) => {
  switch (sourceType) {
    case 'google_transcript':
      return { icon: '🎥', label: 'Google Meet transcript' };
    case 'manual_transcript':
      return { icon: '📝', label: 'Manual transcript' };
    case 'whiteboard':
      return { icon: '🧩', label: 'Whiteboard session' };
    case 'audio_file':
    default:
      return { icon: '🎧', label: 'Audio session' };
  }
};

const TimelineItem = ({
  id,
  preview = {},
  sourceType = 'audio_file',
  sessionDate = null,
  hasTranscript: hasTranscriptProp = false,
  selected,
  onClick
}) => {
  const topicsCount = preview?.topics_count || preview?.topics?.length || 0;
  const hasTranscript = hasTranscriptProp || !!preview?.has_transcript || !!preview?.transcript_preview;
  const sourceBadge = getSourceBadge(sourceType);

  const color = useMemo(() => {
    if (topicsCount >= 8) return 'var(--lrbrain-success)';
    if (topicsCount >= 5) return 'var(--lrbrain-accent)';
    return 'var(--lrbrain-warning)';
  }, [topicsCount]);

  const formatDate = (dateValue, sessionId) => {
    if (dateValue) {
      const parsed = new Date(dateValue);
      if (!Number.isNaN(parsed.getTime())) {
        return parsed.toLocaleDateString(undefined, { month: '2-digit', day: '2-digit' });
      }
    }

    const match = sessionId?.match(/audio(\d{4})/i);
    if (match) {
      const code = match[1];
      const m = code.substring(0, 2);
      const d = code.substring(2, 4);
      return `${m}/${d}`;
    }

    const transcriptMatch = sessionId?.match(/^transcript-(\d+)$/i);
    if (transcriptMatch) {
      return `T-${transcriptMatch[1]}`;
    }

    return 'Session';
  };

  const topics = Array.isArray(preview?.topics) ? preview.topics.slice(0, 3) : [];

  return (
    <button
      type="button"
      className={`timeline-item${selected ? ' selected' : ''}`}
      onClick={onClick}
      data-session-id={id}
      role="option"
      aria-selected={selected}
    >
      <span className="marker" style={{ borderColor: color }} />
      <div className="content">
        <div className="row">
          <div className="date">{formatDate(sessionDate, id)}</div>
          <div className="badges">
            <span className="badge count" title="Topics count" style={{ borderColor: color }}>
              {topicsCount}
            </span>
            {hasTranscript && <span className="badge" title="Has transcript">📄</span>}
            <span className="badge" title={sourceBadge.label}>{sourceBadge.icon}</span>
          </div>
        </div>
        {preview?.overview && (
          <div className="overview" title={preview.overview}>{preview.overview}</div>
        )}
        {!!topics.length && (
          <div className="topics">
            {topics.map((t, i) => (
              <span key={i} className="chip">{t}</span>
            ))}
            {preview?.topics_count > topics.length && (
              <span className="chip more">+{preview.topics_count - topics.length}</span>
            )}
          </div>
        )}
      </div>
    </button>
  );
};

export default TimelineItem;

